<template>
  <v-container style="max-width: 800px" class="pb-0">
    <v-row>
      <v-col cols="6">
        <div class="main_header">Союз отделочников</div>
        <div class="sub_header">
          Платформа с заказами на ремонт квартир напрямую от клиентов.
        </div>
        <div class="reg-button" v-if="$vuetify.breakpoint.width > 450">
          <v-btn color="primary" href="#signup">Регистрация</v-btn><br />
          <!--<v-btn class="mt-3" color="primary" href="/#/login"
            >Вход для партнеров</v-btn
          >-->
        </div>
      </v-col>
      <v-col cols="6">
        <img
          :src="`/img/top${$vuetify.breakpoint.xs ? '2' : '1'}.svg`"
          style="width: 100%"
        />
      </v-col>
    </v-row>
    <div
      class="reg-button"
      v-if="$vuetify.breakpoint.width <= 450"
      style="text-align: center"
    >
      <v-btn color="primary" href="/#signup">Регистрация</v-btn><br />
      <!--<v-btn class="mt-3" color="primary" href="/#/login"
        >Вход для партнеров</v-btn
      >-->
    </div>
    <div class="mt-10">
      <div class="header2">Что такое Союз отделочников сегодня:</div>
      <v-row class="mt-5">
        <v-col cols="12" sm="4">
          <v-card style="height: 100%">
            <v-card-text>
              <div style="display: flex">
                <div class="grey_circle">
                  <img src="../../public/img/icon1.svg" style="margin: auto" />
                </div>
              </div>
              <div class="icon_description">
                География: <cities-list></cities-list> России
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card style="height: 100%">
            <v-card-text>
              <div style="display: flex">
                <div class="grey_circle">
                  <img src="../../public/img/icon2.svg" style="margin: auto" />
                </div>
              </div>
              <div class="icon_description">
                Новые клиенты: {{ statCount }}<br />({{ statMonth }})
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="4">
          <v-card style="height: 100%">
            <v-card-text>
              <div style="display: flex">
                <div class="grey_circle">
                  <img src="../../public/img/icon3.svg" style="margin: auto" />
                </div>
              </div>
              <div class="icon_description">
                Комплексный маркетинг
                <!--<div>Готовые сайты с SEO-трафиком, контекстная реклама, SMM, таргет.</div>-->
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <v-row class="mt-12">
      <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
        <img src="../../public/img/partners.svg" style="width: 100%" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        :class="!$vuetify.breakpoint.xs ? 'pl-7' : ''"
        style="margin: auto"
      >
        <div class="header3">Мы активно ищем партнеров</div>
        <div class="pt-5">
          <p class="partner_text">
            Из городов с населением от 300 тыс человек​, профессионально
            занимающихся отделочным бизнесом.
          </p>
          <p class="partner_text mt-5">
            Пройдите регистрацию и мы на 1 неделю бесплатно подключим для вас поток заявок
            на ремонт квартир, коттеджей и офисов напрямую от частных клиентов в вашем
            городе.
          </p>
        </div>
      </v-col>
    </v-row>

    <div class="mt-12" v-if="!successSignup">
      <a name="signup" id="signup"></a>
      <h1 class="header3">Регистрация и доступ к заказам</h1>
      <v-form ref="form" v-model="isValid" :disabled="loadingSignup"
        ><v-row class="pt-5">
          <v-col cols="12" v-if="Boolean(serverError)">
            <v-alert dense outlined type="error">
              {{ serverError }}
            </v-alert>
          </v-col>
          <!--<v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-text-field
              label="Фамилия *"
              v-model="user.familyName"
              filled
              :rules="[(v) => !!v || 'Введите фамилию.']"
            ></v-text-field>
          </v-col>-->
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-text-field
              label="Как вас зовут *"
              v-model="user.firstName"
              filled
              :rules="[(v) => !!v || 'Введите имя.']"
            ></v-text-field>
          </v-col>
          <!--<v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-text-field
              label="Отчество"
              v-model="user.middleName"
              filled
            ></v-text-field>
          </v-col>-->
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-autocomplete
              :items="cities"
              label="Выберите ваш город *"
              v-model="user.partnerCV.city"
              filled
              :rules="[(v) => !!v || 'Выберите ваш город.']"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-text-field
              label="Ваш email *"
              v-model="user.email"
              filled
              :rules="[
                (v) => !!v || 'Введите email.',
                (v) => isEmail(v) || 'Введите правильный email.',
              ]"
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-text-field
              label="Ваш телефон *"
              v-model="user.partnerCV.phoneNumber"
              filled
              v-mask="'##########'"
              :prefix="phonePrefix"
              @focus="phonePrefix = '+7'"
              @blur="user.partnerCV.phoneNumber || (phonePrefix = '')"
              :rules="[
                (v) => !!v || 'Введите телефон.',
                (v) => v.length == 10 || 'Введите правильный телефон.',
              ]"
            ></v-text-field>
          </v-col>
          <!--<v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-select
              :items="statuses"
              label="Ваш статус *"
              v-model="user.partnerCV.status"
              filled
              :rules="[(v) => !!v || 'Выберите ваш статус.']"
            ></v-select>
          </v-col>
          <v-col cols="12" sm="6" class="pt-0 pb-0">
            <v-select
              :items="legalStatuses"
              label="Юридический статус *"
              v-model="user.partnerCV.legalStatus"
              filled
              :rules="[(v) => !!v || 'Выберите ваш юр. статус.']"
            ></v-select>
          </v-col>
          <v-col cols="12" class="pt-0 pb-0">
            <v-textarea
              label="Дополнительная информация"
              v-model="user.partnerCV.about"
              placeholder="Опыт в отделке, состав бригады, сколько объектов сейчас в работе и сколько еще готовы вести и т.д."
              filled
            ></v-textarea>
          </v-col>!-->
          <v-col cols="12" class="pt-0 pb-0">
            <v-btn
              :disabled="!agreeRules"
              :loading="loadingSignup"
              color="primary"
              @click="signup()"
              >Зарегистрироваться</v-btn
            >
            <div>
              <v-checkbox
                v-model="agreeRules"
                label="Нажимая кнопку Зарегистрироваться я даю согласие на обработку моих персональных данных в соответствие с ​Политикой конфиденциальности.​"
              ></v-checkbox>
            </div>
          </v-col> </v-row
      ></v-form>
    </div>

    <div class="mt-12" v-else>
      <v-row>
        <v-col cols="12" sm="6" style="margin: auto">
          <div class="header3">Вы успешно зарегистрировались на платформе</div>
          <div class="success_text">
            На указанный email ({{ user.email }}) выслано письмо с паролем.
          </div>
          <div class="success_btn">
            <v-btn color="primary" to="/login">Войти на платформу</v-btn>
          </div>
        </v-col>
        <v-col cols="6" v-if="!$vuetify.breakpoint.xs">
          <img src="../../public/img/success.svg" style="width: 100%" />
        </v-col>
      </v-row>
    </div>

    <div class="pa-0 ma-0 mt-10">
      <img
        class="pa-0 ma-0"
        src="../../public/img/bottom.svg"
        style="width: 100%; display: block"
      />
    </div>
    <div class="ma-0 bottom">
      <v-row class="pa-0 ma-0">
        <v-col cols="12" sm="4">
          <span>© Союз отделочников, 2020</span>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          :style="$vuetify.breakpoint.xs ? '' : 'text-align: center;'"
        >
          <user-agreement></user-agreement>
        </v-col>
        <v-col
          cols="12"
          sm="4"
          :style="$vuetify.breakpoint.xs ? '' : 'text-align: right;'"
        >
          <a href="/#/login">Вход для партнеров</a>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import UserAgreement from "../components/common/UserAgreement";
import CitiesList from "../components/common/CitiesList";

export default {
  components: {
    UserAgreement,
    CitiesList,
  },

  data() {
    return {
      isValid: false,
      agreeRules: true,
      phonePrefix: "",
      serverError: "",
      successSignup: false,

      user: {
        role: "partner",
        firstName: "",
        middleName: "",
        familyName: "-",
        email: "",
        partnerCV: {
          phoneNumber: "",
          city: "",
          status: "",
          legalStatus: "",
          about: "",
        },
        utm: {

        }
      },

      statuses: [
        "Подрядчик (компания)",
        "Инженер (прораб)",
        "Бригада",
        "Частный мастер",
        "Дизайнер интерьера",
      ],
      legalStatuses: ["Частное лицо", "Самозанятый", "ИП", "ООО"],

      statCount: 2534,
      statMonth: "июль 2020",
    };
  },

  created() {
    this.$store.dispatch("sites/loadCitiesList");
    this.$store.dispatch("customers/loadPublicStat").then((res) => {
      this.statCount = res.count;
      this.statMonth = res.month;
    });
    document.title = "Союз отделочников";
  },

  methods: {
    signup() {
      this.$refs.form.validate();
      if (this.isValid) {
        //alert(1);
        // Обогащаем User данными по utm-меткам
        if (localStorage.getItem('utm_source')) {
          this.user.utm = {
            source: localStorage.getItem('utm_source'),
            medium: localStorage.getItem('utm_medium'),
            campaign: localStorage.getItem('utm_campaign'),
            term: localStorage.getItem('utm_term'),
            content: localStorage.getItem('utm_content'),
          }
          console.log(this.user.utm);
        }
        this.$store
          .dispatch("users/signup", this.user)
          .then((res) => {
            ym(79710724, "reachGoal", "user"); // Отправляем лид в Метрику
            //fbq("track", "CompleteRegistration"); // Фиксируем конверсию в Facebook
            //gtag("event", "signup", { city: this.user.partnerCV.city }); // Отправляем лид в GA

            this.successSignup = true;
          })
          .catch((err) => {
            this.serverError = err.message;
          });
      }
    },
  },

  computed: {
    ...mapGetters("sites", ["loadingCities"]),
    ...mapState("sites", ["cities"]),
    ...mapGetters("users", ["loadingSignup"]),
  },
};
</script>

<style scoped>
.main_header {
  padding-top: 30px;
  font-size: 42px;
  font-weight: 700;
  line-height: 87.2%;
  color: #3f3d56;
}
@media screen and (max-width: 599px) {
  .main_header {
    padding-top: 20px;
    font-size: 24px;
  }
}

.sub_header {
  font-size: 18px;
  color: #656565;
  line-height: 105.7%;
  margin-top: 30px;
}
@media screen and (max-width: 599px) {
  .sub_header {
    font-size: 11px;
  }
}

.reg-button {
  margin-top: 30px;
}

.header2 {
  color: #3f3d56;
  font-size: 24px;
  font-weight: 700;
  text-align: center;
  line-height: 100%;
}

.grey_circle {
  background-image: url(../../public/img/grey_circle.svg);
  background-size: 100%;
  height: 140px;
  width: 140px;
  margin: auto;
  display: flex;
}

.icon_description {
  color: #494949;
  font-size: 18px;
  line-height: 105.7%;
  text-align: center;
  padding-top: 20px;
}

.icon_description div {
  font-size: 12px;
  line-height: 105.7%;
  padding-top: 5px;
}

.header3 {
  font-size: 30px;
  font-weight: 700;
  line-height: 87.2%;
  color: #3f3d56;
}
@media screen and (max-width: 599px) {
  .header3 {
    font-size: 24px;
  }
}

.partner_text {
  color: #666666;
  font-size: 16px;
  line-height: 100%;
}

.success_text {
  margin-top: 20px;
  color: #666666;
  font-size: 16px;
  line-height: 100%;
}

.success_btn {
  margin-top: 20px;
}

.bottom {
  color: white;
  background-color: #3f3d56;
  font-size: 14px;
  padding: 10px;
}
.bottom a {
  color: white;
}
</style>